import instoreOfferModal from './instoreOfferModal';

export default instoreOfferModal;
